module.exports = __webpack_public_path__ + "img/kommune-2017.62cc4f6e.svg";